import { mpClickDocLink } from "./mixpanel";

export const appUtmParams = "?utm_source=intelligems_app";

export const openNewTab = (
  link: string,
  mixpanelTracker?: string,
  noUtmParams?: boolean
) => {
  const fixedLink = link.startsWith("http") ? link : "https://" + link;

  const url = new URL(fixedLink);
  if (!noUtmParams) {
    url.searchParams.set("utm_source", "intelligems_app");
  }

  window.open(url.toString(), "_blank", "noopener noreferrer");
  if (mixpanelTracker) {
    mpClickDocLink(mixpanelTracker);
  }
};
